import React from 'react';
import jubileeLogo from '../../../assets/img/Jubilee-Logo.jpeg';

export default function JubileeSpinner({ message = 'Loading MDU Platinum Jubilee Archive...', fullPage = false }) {
  const content = (
    <div className="d-flex flex-column align-items-center justify-content-center p-4 text-center">
      {/* Animated Glowing Logo Spinner */}
      <div className="position-relative mb-3" style={{ width: '100px', height: '100px' }}>
        {/* Outer Rotating Glowing Ring */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100 rounded-circle"
          style={{
            border: '3px solid transparent',
            borderTopColor: '#d4af37',
            borderRightColor: '#198754',
            borderBottomColor: '#d4af37',
            borderLeftColor: '#198754',
            animation: 'jubileeSpin 1.4s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite',
            boxShadow: '0 0 20px rgba(212, 175, 55, 0.35)',
          }}
        />

        {/* Inner Logo */}
        <div
          className="w-100 h-100 rounded-circle overflow-hidden p-1 d-flex align-items-center justify-content-center bg-white shadow-sm"
          style={{
            animation: 'jubileePulse 2s ease-in-out infinite alternate',
          }}
        >
          <img
            src={jubileeLogo}
            alt="MDU Platinum Jubilee Logo"
            className="w-100 h-100 rounded-circle object-fit-cover"
            onError={(e) => {
              e.target.src = process.env.PUBLIC_URL + '/assets/img/Jubilee-Logo.jpeg';
            }}
          />
        </div>
      </div>

      <div className="fw-bold text-slate-900 small mb-1" style={{ letterSpacing: '0.5px', color: '#0f5132' }}>
        {message}
      </div>
      <div className="text-muted text-xs">
        Jesuit Madurai Province Archives (1951 - 2026)
      </div>

      <style>{`
        @keyframes jubileeSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes jubileePulse {
          0% { transform: scale(0.92); opacity: 0.88; }
          100% { transform: scale(1.04); opacity: 1; }
        }
      `}</style>
    </div>
  );

  if (fullPage) {
    return (
      <div
        className="fixed-top vw-100 vh-100 d-flex align-items-center justify-content-center"
        style={{
          background: 'rgba(255, 255, 255, 0.94)',
          backdropFilter: 'blur(10px)',
          zIndex: 9999,
        }}
      >
        {content}
      </div>
    );
  }

  return content;
}
